export default "__VITE_ASSET__IbXN2KPG__"